import { HttpErrorResponse } from '@angular/common/http';

export class ListOfficerActionResult {
  constructor(public actionType: ActionType, public httpErrorResponse: HttpErrorResponse | string, public isSuccess: boolean) {}
}

export enum ActionType {
  DeleteOfficer = 'DeleteOfficer',
  InviteUser = 'InviteUser',
}
